import { PLATFORM_PARTNER_ID } from 'src/constants/platform';
import {
  hasNonBpoPartnerAccess,
  hasPlatformPartnerAccess,
} from 'src/graphql/entities/group-rules/group-rules.helpers';
import {
  PartnerGroupRules,
  UserGroupRules,
} from 'src/graphql/entities/group-rules/group-rules.types';
import { sortAlphabetically } from 'src/utils/sorting';
import type { Partner } from './partner';

export interface PartnersFilterByAccessParams {
  partners: Record<string, Partner>;
  groupRules: Partial<Record<PartnerGroupRules | UserGroupRules, boolean | number[]>>;
  user: { partnerId: number } | null | undefined;
  rulesByPartner: Map<number, Record<PartnerGroupRules, boolean>>;
  currentPartnerOnly: boolean;
}

export const filterPartnersByAccess = ({
  partners,
  groupRules,
  user,
  rulesByPartner,
  currentPartnerOnly,
}: PartnersFilterByAccessParams): Partner[] => {
  const list = Object.values(partners);
  const partnerIdsRuleValue = groupRules[UserGroupRules.AvailablePartnerIds];
  const canAccessNonBpoPartners = hasNonBpoPartnerAccess(groupRules);

  const filtered = list.filter((partner) => {
    if (currentPartnerOnly && partner.currentPartner === 'no') {
      return false;
    }

    if (user?.partnerId === partner.partnerId) {
      return true;
    }

    if (partner.partnerId === PLATFORM_PARTNER_ID) {
      if (!hasPlatformPartnerAccess(groupRules)) {
        return false;
      }

      if (
        user?.partnerId !== PLATFORM_PARTNER_ID &&
        Array.isArray(partnerIdsRuleValue) &&
        !partnerIdsRuleValue.includes(PLATFORM_PARTNER_ID)
      ) {
        return false;
      }
    }

    const row = rulesByPartner.get(partner.id);
    if (!row?.[PartnerGroupRules.AccessToOnevisionBpo]) {
      if (!canAccessNonBpoPartners) {
        return false;
      }
    }

    return true;
  });

  return filtered.sort(sortAlphabetically('businessName'));
};
